// Core header functionality
import { setHeaderHeightVar } from "./utils/headerHeight.js";

function header() {
  setHeaderHeightVar();

  // Region Toggle
  const regionToggles = Array.from(
    document.querySelectorAll("[data-region-toggle]")
  );
  const regionMenus = Array.from(
    document.querySelectorAll("[data-region-menu]")
  );
  const regionCloses = Array.from(
    document.querySelectorAll("[data-region-close]")
  );

  if (regionToggles.length > 0 && regionMenus.length) {
    regionToggles.map((regionToggle) => {
      regionToggle.addEventListener("click", (e) => {
        e.preventDefault();
        regionMenus.map((regionMenu) => {
          regionMenu.dataset.regionMenu =
            regionMenu.dataset.regionMenu === "active" ? "inactive" : "active";
        });
      });
    });
  }

  if (regionCloses.length && regionMenus.length) {
    regionCloses.map((regionClose) => {
      regionClose.addEventListener("click", () => {
        regionMenus.map((regionMenu) => {
          regionMenu.dataset.regionMenu = "inactive";
        });
      });
    });
  }

  // Hide / show the header on scroll
  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("[data-header]");
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 100 && currentScrollY > lastScrollY) {
        header.classList.add("scrolled");
      } else if (lastScrollY > currentScrollY) {
        header.classList.remove("scrolled");
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    });
  });
}

export { header };
